import {WindowParam} from "../../../library/context/WindowContext";
import {isIpad, isMobile} from "../../../library/util/userAgentUtil";
import {SizeAttr} from "../../../library/basic/size";

export function appEffectiveWidth(wp: WindowParam): string {
    let isPhone = isMobile();
    let windowWidth = wp.currWidth;

    let ld = window.location.href.includes("spActivity/final202406/loadingAndStart")

    if (ld) {
        if (isPhone) {
            if (windowWidth < 300) {
                return "300px"
            }
            return windowWidth + "px"
        } else if (isIpad()) {
            if (windowWidth > 450) {
                return "450px"
            }
            if (windowWidth < 300) {
                return "300px"
            }
            return windowWidth + "px"
        } else {
            let gap = 350;
            if (wp.currHeight <= 700) {
                gap = 300;
            }
            if (windowWidth > gap && !isPhone) {
                return gap + "px";
            } else if (windowWidth < 300) {
                return "300px"
            } else {
                return windowWidth + "px"
            }
        }
    } else {
        if (windowWidth > 450 && !isPhone) {
            return "450px";
        } else if (windowWidth < 300) {
            return "300px"
        } else {
            return windowWidth + "px"
        }
    }
}

export function ewSize(wp: WindowParam, s: number): string {
    return SizeAttr.pxMultiple(SizeAttr.pxDivide(appEffectiveWidth(wp), 375), s)
}

export function ewSize343(wp: WindowParam): string {
    return SizeAttr.pxMultiple(SizeAttr.pxDivide(appEffectiveWidth(wp), 375), 343)
}